import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppClientConfigurationService, DialogService, AppServerAPI } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { Transport } from '../../../common/model/transport.model';
import { TransportAttachDetachDialogComponent } from '../../../components/attach-detach/component/transport-attach-detach-dialog.component';
import { AttachDetachDetails } from '../../../components/attach-detach/model/attach-detach-details';

@Component({
  selector: 'app-attach-detach-transport-dialog-action',
  templateUrl: './attach-detach-transport-dialog-action.component.html',
  styleUrls: ['./attach-detach-transport-dialog-action.component.scss']
})
export class AttachDetachTransportDialogActionComponent {

  @Input() disabled = false;

  @Input() transport: Transport;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter();

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private configurationService: AppClientConfigurationService,
    private appServerAPI: AppServerAPI
  ) { }

  clickButton() {

    this.appServerAPI.execute<AttachDetachDetails>('/client/control/attach-detach/details', { id: this.transport.id })
      .subscribe(
        result => {
          this.dialogService.openMiddle(TransportAttachDetachDialogComponent, { details: result }).afterClosed().subscribe(() => {
            this.onChange.next();
          });
        }, error => {
          console.log('Error loading AttachDetachDetails', error);
        });

  }
}

